import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';

import { API } from '../../shared/constants/api.constants';
import { Substitute, SubstituteData, SubstitutePaginatedResponse } from '../../shared/models/substitute.model';
import { ErrorHandlingHttpClient } from '../../shared/services/error-handling-http-client.service';
import {
  deleteSubstitute,
  loadSubstitutes,
  loadSubstitutesFailure,
  loadSubstitutesSuccess,
  reloadSubstitutes,
} from './substitute.actions';


@Injectable()
export class SubstituteEffects {
  private forwardData(item: SubstituteData): Substitute {
    return {
      ...item,
      startDate: item.startDate ? item.startDate : null,
      endDate: item.endDate ? item.endDate : null
    };
  }
  loadSubstitutes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSubstitutes),
      exhaustMap(({scope}) => {
        let dataProvider: Observable<any> = EMPTY;
        if (scope === 'all') {
          dataProvider = this.errorHandlingHttpClient
            .get<SubstitutePaginatedResponse>(API.adminSubstitutes(), {
              params: {
                ['page.number']: 0,
                ['page.size']: 2147483647,
              }
            });
        } else if (scope === 'my') {
          dataProvider = this.errorHandlingHttpClient.get<SubstitutePaginatedResponse>(API.substitutes(), {
            params: {
              ['page.number']: 0,
              ['page.size']: 2147483647,
            }
          });
        }

        return dataProvider.pipe(
          map(
            data => loadSubstitutesSuccess({data: data.content.map(i => this.forwardData(i))}),
            error => loadSubstitutesFailure(error)
          )
        );
      })
    )
  );
  deleteSubstitute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteSubstitute),
      exhaustMap(({userName, substituteUserName, scope}) => {
        let dataProvider: Observable<any> = EMPTY;
        if (scope === 'all') {
          dataProvider = this.errorHandlingHttpClient.delete<SubstituteData[]>(API.adminSubstitute(userName, substituteUserName));
        } else if (scope === 'my') {
          dataProvider = this.errorHandlingHttpClient.delete<SubstituteData[]>(API.substitute(substituteUserName));
        }

        return dataProvider.pipe(
          map(
            () => reloadSubstitutes(),
            () => reloadSubstitutes()
          )
        );
      })
    )
  );

  constructor(private actions$: Actions, private errorHandlingHttpClient: ErrorHandlingHttpClient) {}
}
